import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ensureActiveSubscription } from 'src/app/shared/subscription-dialog';
import { ConfirmationDialogService } from 'src/app/confirmation-dialog/confirmation-dialog.service';

@Component({
    selector: 'create-relationship',
    templateUrl: 'create-relationship.component.html',
    styleUrls: ['create-relationship.component.scss'],
    standalone: false
})
export class CreateRelationshipComponent {

    constructor(private fb:FormBuilder, private confirmationDialogService: ConfirmationDialogService, private router:Router){
        this.router.events.subscribe((val) => {
            if(this.router.url.includes('individual')){
                this.activeTab = 'individual'
            }
            if(this.router.url.includes('entity')){
                this.activeTab = 'entity'
            }
            if(this.router.url.includes('corporate')){
                this.activeTab = 'corporate'
            }
        });
    }

    product = environment.product;
    createRelationform: any = FormGroup;
    submitted:boolean = false;
    searchForm = this.fb.group({email: ['']})
    activeTab: string = "individual";
    successModel: boolean = false;
    isDisplay: boolean = true;

    ngOnInit(){
        if (!ensureActiveSubscription(this.confirmationDialogService)) { return; }
    }
    
    get f() { return this.createRelationform.controls; }

    onSubmit(){
        this.submitted = true;
    }
    onReset() {
        this.submitted = false;
    }
        // Just reset the tab when clicked.
        tabReset(name: string){
            this.activeTab = name;
        }

    onClick() {
        if (!ensureActiveSubscription(this.confirmationDialogService)) { return; }

        if (this.product === 'corporate') {
            this.router.navigate(['/relationship/add/corporate'])
        }
        else {
            this.router.navigate(['/relationship/add/individual'])
        }
        // this.selectedMatter = value;
        // this.selectedMatter == 'legalmatter' ? this.router.navigate(['/matter/legalmatter/create']) : this.router.navigate(['/matter/generalmatter/create']);
    }
    
    hideAndShow() {
        this.isDisplay = !this.isDisplay;
    }
}
